import Vuex from "vuex";
import Vue from "vue";
import createPersistedState from "vuex-persistedstate";
import auth from "./modules/auth";
import payment from "./modules/payment";
import transfer from "./modules/transfer";
import lang from "./modules/lang";
import utm from "./modules/utm";
import personal from "./modules/personal";
import recipients from "./modules/recipients.js";
import header from "./modules/header";
import wallet from "./modules/wallet";
import admin from "./modules/admin.js";

// Load Vuex
// Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        auth,
        payment,
        transfer,
        lang,
        utm,
        personal,
        recipients,
        header,
        wallet,
        admin,
    },
    plugins: [createPersistedState()],
})